import { useQuery } from "react-query";
import { TradeInApi } from "../../services";
export const GET_TRADE_IN_CONFIGURATION_QUERY_KEY_BASE = "GET_TRADE_IN_CONFIGURATION";
export const useGetTradeInConfiguration = () => {
    const tradeInApi = new TradeInApi();
    return useQuery({
        queryKey: [GET_TRADE_IN_CONFIGURATION_QUERY_KEY_BASE],
        queryFn: () => tradeInApi.getConfiguration(),
        staleTime: 5000,
        retry: false,
        select: (data) => data.data,
    });
};
//# sourceMappingURL=useGetTradeInConfiguration.js.map